import { createActions } from "../../helpers/utils/createActions";
import { BUSINESS } from "./actionTypes";

export const getListaBusiness = createActions(BUSINESS.GET_LISTA_BUSINESS);
export const getBusiness = createActions(BUSINESS.GET_BUSINESS);
export const saveBusiness = createActions(BUSINESS.SAVE_BUSINESS);

export const loadEmptyBusiness = () => ({ type: BUSINESS.LOAD_EMPTY_BUSINESS });
export const cleanMessageBusiness = () => ({
  type: BUSINESS.CLEAN_MESSAGE_BUSINESS,
});
export const changePageSizeBusiness = (payload) => ({ type: BUSINESS.CHANGE_PAGE_SIZE_BUSINESS, payload });
